<template>
  <div>
    <div class="d-flex justify-space-between align-center">
      <h2 class="page-title-bar">
        <i class="ico ico-multi"></i>{{ $t("Button Configuration") }}
      </h2>

      <v-menu v-model="menuOpen" offset-y :close-on-content-click="false" content-class="columnMenu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text small class="manage-btn btn" v-bind="attrs" v-on="on">
              {{ $t('Manage Columns') }}
              <v-icon right :class="{ rotate: menuOpen }">
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>

          <v-card class="column-card">
            <v-card-title class="column-header">
              {{ $t('Select Columns') }}
            </v-card-title>
            <v-divider />
            <v-list dense class="select-all">
              <v-list-item>
                <v-checkbox :input-value="isAllSelected" @change="toggleSelectAll" hide-details />
                <v-list-item-title>
                  {{ $t('Select All') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-divider />
            <v-card-text class="column-list">
              <v-list dense>
                <v-list-item v-for="header in tableHeaders" :key="header.value">
                  <v-checkbox v-model="visibleColumns" :value="header.text" hide-details />
                  <v-list-item-title class="column-text">
                    {{ header.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions class="column-footer">
              <v-btn color="error" style="background: #c57171;color: #ffffff !important;width:80px" text small
                @click="menuOpen = false">
                {{ $t('Cancel') }}
              </v-btn>
              <v-spacer />
              <v-btn color="primary" small style="width:80px" @click="menuOpen = false; saveVisibleColumns()">
                {{ $t('Save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
    </div>
    <div class="col-12 pl-0 pb-0 pt-0 pr-0 d-flex" style="margin-top:10px">

      <div :class="[$vuetify.breakpoint.width >= 1375 ? 'col-3' : 'col-4']" class="pr-0 pt-0">
        <v-data-table v-model="selected" :server-items-length="totalProducts" :headers="tableHeadersFreeze"
          :hide-default-footer="true" :item-class="getRowClass" :items="ButtonConfigTableList" :single-select="true"
          :options.sync="options" @click:row="openButtonConfigEditPopup" class="tbl-type01 mt-10 products" show-select
          item-key="configName">
          <!-- No Data Slot -->
          <template slot="no-data">
            <p>
              {{ $t('No data available') }}
            </p>
          </template>
          <template v-slot:item.data-table-select="{ item }">
    <v-checkbox
    class="custom-checkbox "
      :value="selected.includes(item)"
      :disabled="item.id === 1"
      style="height: 40px;"
      @click.stop="toggleSelect(item);"
    />
  </template>
        </v-data-table>
      </div>
      <!-- Main Table -->
      <div :class="[$vuetify.breakpoint.width >= 1375 ? 'col-9' : 'col-8']" class="col-8 pl-0 pt-0 pr-1">
        <v-data-table v-model="selected" :server-items-length="totalProducts" :headers="filteredTableHeaders"
          :hide-default-footer="true" :item-class="getRowClass" :items="ButtonConfigTableList" :single-select="true"
          :options.sync="options" @click:row="openButtonConfigEditPopup" class="tbl-type01 mt-10 tblBorder"
          item-key="configName">
          <!-- No Data Slot -->
          <template slot="no-data">
            <p>
              {{ $t('No data available') }}
            </p>
          </template>
          <template v-slot:[`item.realtimeConfigHibernate`]="{ item }">
            {{ item.realtimeConfigHibernate === true ? 'ON' : 'OFF' }}
          </template>
        </v-data-table>
      </div>
    </div>
    <div class="table-options">
      <div>
        <v-btn class="btn ml-2" text :disabled="btnDisabledNewDelete" @click="openNewButtonConfigPopup">{{ $t("New") }}
        </v-btn>
        <v-btn :disabled="btnDisabledNewDelete || checkSelected" @click="clickDelete" class="btn ml-2" text>{{
          $t('Delete')
        }}
        </v-btn>
      </div>
    </div>
    <EditButtonConfig :selectedItem="selectedItem" :dialogPopup="editDialogPopup" @reload="reload"></EditButtonConfig>
    <AddButtonConfig :dialogPopup="addDialogPopup" @reload="reload"></AddButtonConfig>
    <a ref="link" :style="{ display: 'none' }" />
  </div>
</template>

<script>
import EventBus from '@/plugins/eventBus'
import codes from '@/plugins/codes'
import AddButtonConfig from './modal/AddButtonConfig.vue'
import EditButtonConfig from './modal/EditButtonConfig.vue'

export default {
  name: 'ButtonConfig',
  components: {
    AddButtonConfig,
    EditButtonConfig
  },
  data () {
    return {
      btnDisabledNewDelete: null,
      btnDisabledDetail: null,
      btnDisabledExport: null,
      page: 0,
      ButtonConfigTableList: [],
      selected: [],
      options: {},
      // New Button Config
      addDialogPopup: false,
      editDialogPopup: false,
      totalProducts: 10,
      selectedItem: null,
      menuOpen: false,
      visibleColumns: []
    }
  },
  computed: {
    tableHeadersFreeze () {
      return [
        {
          text: this.$t('BUTTON CONFIG NAME (ID)'),
          sortable: false,
          value: 'name',
          width: '80%'
        }
      ]
    },
    tableHeaders () {
      return [
        { text: this.$t('BUTTON 1 (MAIN)'), sortable: false, value: 'SHORT_MAIN' },
        { text: this.$t('BUTTON 1 (MAIN)Long'), sortable: false, value: 'LONG_MAIN' },

        {
          text: this.$t('BUTTON 2 (SUB)'),
          sortable: false,
          value: 'SHORT_SUB'
        },
        {
          text: this.$t('BUTTON 2 (SUB)Long'),
          sortable: false,
          value: 'LONG_SUB'
        },
        {
          text: this.$t('BUTTON 3 (EXTEND1)'),
          sortable: false,
          value: 'SHORT_EXTEND1'
        },
        {
          text: this.$t('BUTTON 3 (EXTEND1)Long'),
          sortable: false,
          value: 'LONG_EXTEND1'
        },
        // {
        //   text: this.$t('BUTTON 4 (EXTEND2)'),
        //   sortable: false,
        //   value: 'SHORT_EXTEND2'
        // },
        // {
        //   text: this.$t('BUTTON 4 (EXTEND2)Long'),
        //   sortable: false,
        //   value: 'LONG_EXTEND2'
        // },
        {
          text: this.$t('LOW POWER MODE'),
          sortable: false,
          value: 'realtimeConfigHibernate'
        }
      ]
    },
    checkSelected () {
      var flag = true
      if (this.selected.length === 1) flag = false
      return flag
    },
    isAllSelected () {
      return (
        this.tableHeaders.length > 0 &&
        this.visibleColumns.length === this.tableHeaders.length
      )
    },
    filteredTableHeaders () {
      return this.tableHeaders.filter(h =>
        this.visibleColumns.includes(h.text)
      )
    }
  },
  watch: {},
  mounted () {
    this.clearTabindex()
    // button  권한 체크
    // button Config : New / Delete / Edit
    this.$store.dispatch('auth/getDisabledBtn', '6401').then(flag => {
      this.btnDisabledNewDelete = flag
    })

    EventBus.$emit('enableSelectedStores', false)
    // 검색조건 설정
    this.togetButtonConfigList()
    this.togetCustomCloumn()
  },
  methods: {
    toggleSelectAll (value) {
      if (value) {
        this.visibleColumns = this.tableHeaders.map(h => h.text)
      } else {
        this.visibleColumns = []
      }
    },
    openNewButtonConfigPopup () {
      this.addDialogPopup = true
    },
    openButtonConfigEditPopup (item) {
      if (!this.btnDisabledNewDelete) {
        console.log(item)
        this.editDialogPopup = false
        this.selectedItem = item
        this.editDialogPopup = true
      }
    },
    getRowClass (item) {
      // return item.configName === 'DEFAULT' ? 'disabled-row' : '' || item.id === 1 ? 'disabled-row' : ''
    },
    reload (refresh) {
      console.log(refresh)
      this.dialogPopup = false
      this.addDialogPopup = false
      this.editDialogPopup = false
      if (refresh) this.togetButtonConfigList()
    },
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    togetButtonConfigList () {
      const params = {}
      const config = { params }
      this.$utils
        .callAxios(
          codes.requests.toGetButtonConfig.method,
          codes.requests.toGetButtonConfig.url,
          config
        )
        .then(res => {
          console.log(res)
          var data = res.data.configList
          this.ButtonConfigTableList = data.map(config => ({
            id: config.id,
            name: `${config.configName} (${config.id})`,
            SHORT_MAIN: config.buttonSet.SHORT_MAIN,
            SHORT_SUB: config.buttonSet.SHORT_SUB,
            SHORT_EXTEND1: config.buttonSet.SHORT_EXTEND1,
            SHORT_EXTEND2: config.buttonSet.SHORT_EXTEND2,
            LONG_MAIN: config.buttonSet.LONG_MAIN,
            LONG_SUB: config.buttonSet.LONG_SUB,
            LONG_EXTEND1: config.buttonSet.LONG_EXTEND1,
            LONG_EXTEND2: config.buttonSet.LONG_EXTEND2,
            realtimeConfigHibernate: config.realtimeConfigHibernate,
            created: config.created,
            lastModified: config.lastModified
          }))
        }).catch(error => {
          if (error.response !== undefined) {
            EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
          } else {
            EventBus.$emit('messageAlert', this.$t('Failed to get Button Config list.'))
          }
          console.log(`Failed to delete anchors ${error}`)
        })
    },
    toggleSelect (item) {
      this.editDialogPopup = false
      if (item.id !== 1) {
        const index = this.selected.indexOf(item)
        if (index === -1) {
          this.selected = [item]
        } else {
          this.selected = []
        }
      } else {
        console.log('Selection disabled for this item')
      }
    },
    async clickDelete () {
      const ok = await this.$confirm.open({
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete selected button configs?',
        note: 'If this button configuration is currently assigned to any ESLs, those ESLs will no longer be able to use this configuration after deletion.'
      })
      if (!ok) return
      console.log(this.selected[0].id)
      const config = { params: {} }
      this.$utils.callAxios(
        codes.requests.toDeleteButtonConfig.method,
        codes.requests.toDeleteButtonConfig.url + '/' + `${this.selected[0].id}`,
        config
      )
        .then(res => {
          EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
          this.togetButtonConfigList()
          this.selected = []
        }).catch(error => {
          if (error.response !== undefined) {
            EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
          } else {
            EventBus.$emit('messageAlert', this.$t('Failed to delete a Config.'))
          }
          console.log(`Failed to delete Config ${error}`)
          this.selected = []
        })
    },

    paging (page) { this.searchAccountList(page) },
    togetCustomCloumn () {
      const params = { userId: this.$store.state.auth.user.account, type: 'BUTTON_CONFIG' }
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getCustomColoumnlist.method,
          codes.requests.getCustomColoumnlist.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            console.log(res.data)
            const data = res.data
            const apiColumns = data['6400'] || []
            if (apiColumns.length > 0) {
              this.visibleColumns = apiColumns.filter(text =>
                this.tableHeaders.some(h => h.text === text)
              )
            } else {
              this.visibleColumns = []
            }
          } else {
            this.visibleColumns = this.tableHeaders.map(h => h.text)
          }
        })
        .catch(error => {
          console.log(error)
          this.visibleColumns = this.tableHeaders.map(h => h.text)
        })
    },
    saveVisibleColumns () {
      const body = {
        6400: this.visibleColumns
      }
      const params = { userId: this.$store.state.auth.user.account, type: 'BUTTON_CONFIG' }
      this.$utils
        .callAxiosWithBody(
          codes.requests.updateCustomColoumnlist.method,
          codes.requests.updateCustomColoumnlist.url,
          body,
          { params: params }
        )
        .then(res => {
          if (res.status === 200) {
            console.log(res.data)
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.togetCustomCloumn()
          }
        })
        .catch(error => {
          console.log(error)
        })
    }

  }
}
</script>
<style>
.row-class:hover {
  cursor: pointer;
}

.pageAlign {
  float: right;

}

::-webkit-scrollbar {
  height: 8px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

.tblBorder th {
  min-width: 180px !important;
}
.disabled-row {
  pointer-events: none;
  opacity: 0.5;
}
.custom-checkbox {
  /* height: 30px !important;      Adjust this value to change the height */
  width: 24px;       /* Adjust width if necessary */
  line-height: 24px; /* This aligns the content vertically */
}

.custom-checkbox .v-input--selection-controls__input {
  height: 24px;
  margin-top: 10px !important;     /* Adjust height of the input */
}
.custom-checkbox .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.columnMenu {
  max-width: 200px;
  top: 250px;
}

.columnMenu {
  max-width: 260px;
}

.column-card {
  width: 100%;
  max-width: 260px;
}

.column-header {
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
}

.column-list {
  max-height: 260px;
  overflow-y: auto;
  padding: 0 8px;
}

.column-text {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.column-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 8px 12px;
}

.manage-btn {
  max-width: 200px;
  white-space: nowrap;
}

.rotate {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.products th:first-child,
.products td:first-child {
  width: 5% !important;
  min-width: 5% !important;
  max-width: 5% !important;
}

</style>
